var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23 1.17227C9.51934 1.41327 9.58127 1.82602 9.39096 2.13819L9.32628 2.22855L4.32628 8.23148C4.06742 8.54227 3.6151 8.58765 3.30131 8.35262L3.21941 8.28156L0.219411 5.27863C-0.0733391 4.98559 -0.0731073 4.51072 0.219929 4.21797C0.486325 3.95183 0.903001 3.92783 1.19651 4.14582L1.28059 4.21848L3.699 6.63902L8.17372 1.26855C8.43882 0.950283 8.91173 0.907176 9.23 1.17227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickWhite);
export default __webpack_public_path__ + "static/media/Tick-white.256f15910d31ced539dd75468192e0f1.svg";
export { ForwardRef as ReactComponent };